/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import React from 'react';
import StubDescription from 'ud-ui/components/stubs/components/stub-description/stub-description';
import StubLinks from 'ud-ui/components/stubs/components/stub-links/stub-links';
import StubLogo from 'ud-ui/components/stubs/components/stub-logo/stub-logo';
import StubPicture from 'ud-ui/components/stubs/components/stub-picture/stub-picture';
import StubSupportLink from 'ud-ui/components/stubs/components/stub-support-link/stub-support-link';
import StubTitle from 'ud-ui/components/stubs/components/stub-title/stub-title';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: ${({ theme }) => theme.colors.DarkBlue};
  color: ${({ theme }) => theme.colors.InkOnDark};

  gap: 20px;
  padding: 16px;
`;

const MobileStub: React.FC<{ classNames?: string; isLandscape?: boolean }> = (props) => {
  if (props.isLandscape) {
    return (
      <Container className={props.classNames} style={{ padding: '50px' }}>
        <div className="flex gap-5">
          <div className="flex w-1/2 flex-col items-start gap-5 text-left">
            <StubLogo />
            <StubTitle />
            <StubDescription />
          </div>
          <div className="flex w-1/2 flex-col items-center justify-end gap-5">
            <StubLinks />
            <StubSupportLink />
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Container className={props.classNames}>
      <div className="items-left flex flex-col text-left">
        <StubLogo className="mb-5" />
        <StubTitle className="mb-5" />
        <StubDescription className="mb-7.5" />
        <StubPicture className="mb-7.5" />
        <div className="flex w-full flex-col items-center">
          <StubLinks className="mb-10" />
          <StubSupportLink className="text-center" />
        </div>
      </div>
    </Container>
  );
};

export default MobileStub;
